export default __webpack_public_path__ + "static/media/bg-image-desktop.8bc1b775.jpg";